import { render, staticRenderFns } from "./historiqueCollectePop.vue?vue&type=template&id=3605132a&scoped=true"
import script from "./historiqueCollectePop.vue?vue&type=script&lang=js"
export * from "./historiqueCollectePop.vue?vue&type=script&lang=js"
import style0 from "./historiqueCollectePop.vue?vue&type=style&index=0&id=3605132a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3605132a",
  null
  
)

export default component.exports